import React from 'react';
import PropTypes from 'prop-types';

import { Check } from '@components/Icons';
import { CheckboxContainer } from './components/CheckboxContainer';

const Checkbox = ({ selected }) => (
  <CheckboxContainer selected={selected}>
    {selected && <Check color="white" size="xsmall" />}
  </CheckboxContainer>
);

Checkbox.propTypes = {
  selected: PropTypes.bool.isRequired,
};

export default Checkbox;
